import { CustomProduct } from '@/shared/forms/CustomProductsForm/schemas/getCustomProductsFormSchema.ts';
import { getSchemaId } from '@/shared/domain/product/getSchemaId.ts';
import { AdditionalPropertyType } from '@/shared/models/ContextDataModel/interfaces/entities/properties.ts';
import { ProductConfiguration } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';
import { PROCESSING_TYPE } from '@schuettflix/interfaces';

export function convertToProductConfigurations(
    customProducts: readonly CustomProduct[],
    processingType: PROCESSING_TYPE
): ProductConfiguration[] {
    return customProducts.map((customProduct, index) => ({
        ...customProduct,
        id: customProduct.identifier,
        purchaseQuantity: customProduct.quantity,
        salesQuantity: customProduct.quantity,
        purchaseUnit: customProduct.unit,
        salesUnit: customProduct.unit,
        serviceDate: parseServiceDate(customProduct.serviceDate),
        isMainProduct: index === 0,
        index: index + 1,
        processingType,
        additionalProperties: generateAdditionalProperties(customProduct),
    }));
}

function generateAdditionalProperties(customProduct: CustomProduct) {
    return {
        name: customProduct.productName,
        schemaId: getSchemaId(customProduct.productType, customProduct.freightType),
        freightType: customProduct.freightType,
        disposalPurpose: customProduct.disposalPurpose,
        processedBy: 'PARTNER',
    } as AdditionalPropertyType;
}

function parseServiceDate(serviceDate: string | undefined) {
    return serviceDate ? new Date(serviceDate) : undefined;
}
